<template>
    <Dropdown :title="dropdownTitle" :icon="icon" :badge="dropdownBadge" ref="Dropdown" :disabled="disabled">
        <div v-if="hasSearch" class="datatable-select-search">
            <input type="text" v-model="searchValue" placeholder="Пошук"/>
            <i class="icon-search4"></i>
        </div>
        <div class="datatable-select-options">
            <div v-if="isMulti" class="datatable-select-option">
                <CheckBox
                    :modelValue="allValuesIsSelected"
                    @update:modelValue="newValue => selectAllValues(newValue)"
                />
                <span>{{ translate('buttons.select_all') }}</span>
            </div>
            <div class="datatable-select-group" v-for="group in groups">
                <div v-if="!(groups[0] && Object.keys(groups).length === 1)" class="title">{{ group.name }}</div>
                <div v-for="option in group.options" :class="[
                    'datatable-select-option',
                    selectedValues.includes(option.key) ? 'selected' : ''
                ]" @click="!isMulti ? selectValue(option.key, true) : null">
                    <CheckBox
                        v-if="isMulti"
                        :disabled="option.disabled"
                        :modelValue="selectedValues.includes(option.key)"
                        @click="selectValue(option.key, !selectedValues.includes(option.key))"
                    />
                    <span :class="[
                        option.color ? 'badge' : ''
                    ]" :style="[
                        option.color ? {background: option.color, color : 'white'} : {}
                    ]">{{ option.value }}</span>
                </div>
            </div>
        </div>
    </Dropdown>
</template>

<script>
import Dropdown from "./DropdownComponent.vue";
import CheckBox from "../../../new/form/checkbox/AppCheckbox.vue";
export default  {
    name: "DatatableSelectComponent",
    emits: ['update:model-value'],
    props: {
        modelValue: {
            type: [Array, String, Number],
            default() {
                return []
            }
        },
        title: {
            type: String,
            default() {
                return '';
            }
        },
        titleCanChange: {
            type: Boolean,
            default() {
                return true;
            }
        },
        icon: {
            type: String,
            default() {
                return 'icon-arrow-down22';
            }
        },
        isMulti: {
            type: Boolean,
            default() {
                return false;
            }
        },
        hasSearch: {
            type: Boolean,
            default() {
                return false;
            }
        },
        options: {
            type: Array,
            default() {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchValue: ''
        }
    },
    methods: {
        selectValue(identifier, checked) {
            if (!this.isMulti) {
                this.selectedValues = checked ? [identifier] : []
                return this.$refs.Dropdown.hide();
            }

            let oldSelectedValues = [...this.selectedValues];

            if (checked) {
                oldSelectedValues.push(identifier)
            } else {
                oldSelectedValues = oldSelectedValues.filter(selectedId => selectedId !== identifier);
            }

            this.selectedValues = oldSelectedValues
        },
        selectAllValues(checked) {
            this.selectedValues = checked ? this.options.map(element => element.key): this.options.filter(element => element.disabled).map(element => element.key);
        },
    },
    computed: {
        selectedValues: {
            get() {
                if (!this.modelValue) {
                    return [];
                }

                return this.isMulti ? this.modelValue : [this.modelValue];
            },
            set(newValue) {
                let value = this.isMulti ? newValue : newValue[0] ?? []

                this.$emit('update:model-value', value)
            }
        },
        groups() {
            let optionsAfterSearching = this.hasSearch === true && this.searchValue !== ''
                ? this.options.filter(option => option.value.toLowerCase().includes(this.searchValue.toLowerCase()))
                : this.options;

            let optionsAfterGrouping = {};

            optionsAfterSearching.map((option) => {
                option.group_key = option.group_key && option.group_value ? option.group_key : 0;

                if (!optionsAfterGrouping[option.group_key]) {
                    optionsAfterGrouping[option.group_key] = {
                        key: option.group_key,
                        name: option.group_value ?? 'Без сортування',
                        options: []
                    };
                }

                optionsAfterGrouping[option.group_key].options.push({
                    key: option.key,
                    value: option.value,
                    color: option.color,
                    disabled: option.disabled
                });
            });

            return optionsAfterGrouping;
        },
        allValuesIsSelected() {
            return this.selectedValues.length === this.options.length
        },
        dropdownTitle(){
            if (this.selectedValues.length === 0 || !this.titleCanChange) {
                return this.title;
            }

            let firstOption = this.options.filter((option) => this.selectedValues.includes(option.key))[0]

            if (!firstOption) {
                return this.title;
            }

            return this.title + `: ${firstOption.value}`
        },
        dropdownBadge(){
            if (this.selectedValues.length < 2 || !this.titleCanChange) {
                return null
            }

            return `+ ${this.selectedValues.length - 1}`;
        }
    },
    components: {
        CheckBox,
        Dropdown
    }
}
</script>

<style scoped>
.datatable-select-search {
    height: 40px;
    display: flex;
    border-bottom: solid 1px #dfe1e6;
    justify-content: space-between;
    padding: 0 10px;
}

.datatable-select-search input{
    margin: unset;
    padding: unset;
    border: unset;
    width: 200px;
}

.datatable-select-search input:focus {
    outline: none;
}

.datatable-select-search i{
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    width: 20px;
    margin: 10px 0;
}

.datatable-select-options {
    padding: 5px 0;
    max-height: 250px;
    overflow-y: auto;
}

.datatable-select-option {
    display: flex;
    padding: 8px 10px;
    column-gap: 10px;
    transition: background 0.3s;
}

.datatable-select-option:hover {
    background: #eaeaea;
    cursor: pointer;
}

.datatable-select-option.selected {
    background: #f6f6f6;
}

.datatable-select-group .title{
    margin: 10px 10px 0 10px;
    font-weight: 500;
}
</style>
